// src/main.ts
import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const isHiddenFrame = window.self !== window.top;
const hasAuthResponse = /[#&?](code|error)=/.test(
  window.location.hash + window.location.search,
);

if (isHiddenFrame && hasAuthResponse) {
  import('@azure/msal-browser/redirect-bridge')
    .then((bridge) => bridge.broadcastResponseToMainFrame())
    .catch((err) => console.error('Silent auth bridge failed', err));
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
